import React from 'react'
import DeleveryChargeTable from 'components/Tables/DeleveryCharge/DeleveryChargeTable'

const ListDeleveryCharge = () => {
  return (
    <div><DeleveryChargeTable /></div>
  )
}

export default ListDeleveryCharge